<template>
  <CadastroBase
    nomePlural="FuncionarioAvisoPrevios"
    nomeSingular="FuncionarioAvisoPrevio"
    :submitPersonalizado="true"
    :submited="submited"
    @submitSuccessInsert="emitSubmitSuccess"
    @submitErrorInsert="emitSubmitError"
    @closeModalInsert="closeModal"
  >
    <v-col cols="12">
      <v-row>
        <v-col cols="12">
          <BuscaSelecionaFuncionario
            v-model="selectedFuncionario"
            :headers="headersFuncionario"
            :data-service="DataService"
            fetch-method="getFuncionarios"
            item-key="funcionario.matricula"
            :multiple="true"
            :label-formatter="formatFuncionarioLabel"
            info-text="Selecione um ou mais funcionários para aplicar este aviso prévio em lote. Use o checkbox do cabeçalho ou o botão Selecionar todos para marcar a listagem inteira."
          />
        </v-col>
        <v-row>
          <v-col cols="12" md="4" id="campo-dt-inicio">
            <CampoData
              @date="recurso.inicio = $event"
              label="Inicio_do_periodo"
            />
          </v-col>
          <v-col cols="12" md="4" id="campo-dt-encerramento">
            <CampoData
              @date="recurso.encerramento = $event"
              label="Final_do_periodo"
            />
          </v-col>
          <v-col class="d-flex" cols="12" md="4">
            <v-select
              id="origemAvisoPrevio"
              v-model="recurso.origemAvisoPrevio"
              :items="tiposOrigemAvisoPrevio"
              :label="$t('origemAvisoPrevio')"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-select>
          </v-col>
          <v-col class="d-flex" cols="12" md="4">
            <v-select
              id="tipoAvisoPrevio"
              v-model="recurso.tipoAvisoPrevio"
              :items="tiposAvisoPrevio"
              :label="$t('tipoAvisoPrevio')"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-select>
          </v-col>

          <v-col
            class="d-flex"
            cols="12"
            md="4"
            v-if="
              recurso.origemAvisoPrevio === 'EMPRESA' &&
              recurso.tipoAvisoPrevio === 'TRABALHADO'
            "
          >
            <v-select
              id="beneficioAvisoPrevio"
              v-model="recurso.beneficioAvisoPrevio"
              :items="tiposBeneficioAvisoPrevio"
              :label="$t('beneficioAvisoPrevio')"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-select>
          </v-col>
          <v-col cols="12" md="4" id="dataHomologacao">
            <CampoData
              @date="recurso.dataHomologacao = $event"
              label="dataHomologacao"
            />
          </v-col>

          <v-col cols="12" class="">
            <div>
              <v-text-field
                v-model="recurso.observacao"
                :label="$t('Observacao')"
                name="Observacao"
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              >
              </v-text-field>
            </div>
          </v-col>
        </v-row>
      </v-row>
    </v-col>
  </CadastroBase>
</template>

<script>
import CadastroBase from "@/components/base/Crud/CadastroBase";
import BuscaSelecionaFuncionario from "@/components/base/proprios/BuscaSelecionaFuncionario";
import FuncionarioAvisoPrevioDataService from "@/services/pessoal/FuncionarioAvisoPrevioDataService";
const DataService = FuncionarioAvisoPrevioDataService;

import createNumberMask from "text-mask-addons/dist/createNumberMask";
const currencyMask = createNumberMask({
  prefix: "R$",
  allowDecimal: true,
  includeThousandsSeparator: true,
  allowNegative: false,
});

export default {
  components: { CadastroBase, BuscaSelecionaFuncionario },
  name: "CadastroFuncionarioAvisoPrevio",

  data() {
    return {
      DataService: DataService,
      submited: false,
      mask: currencyMask,

      recurso: {
        funcionario: {},
        matricula: "",
        inicio: "",
        encerramento: "",
        tipoAvisoPrevio: null,
        beneficioAvisoPrevio: null,
        origemAvisoPrevio: null,
        observacao: null,
        dataHomologacao: null,
      },
      selectedFuncionario: [],
      headersFuncionario: [
        { text: this.$t("Matricula"), value: "funcionario.matricula" },
        { text: this.$t("Nome"), value: "funcionario.pessoa.nome" },
        {
          text: this.$t("Sindicato"),
          value: "funcionario.sindicato.descricao",
        },
        { text: this.$t("Cargo"), value: "funcionario.cargo.descricao" },
        {
          text: this.$t("PostoTrabalho"),
          value: "funcionario.postoTrabalho.descricao",
        },
      ],

      tiposAvisoPrevio: [
        { text: this.$t("TRABALHADO"), value: "TRABALHADO" },
        { text: this.$t("INDENIZADO"), value: "INDENIZADO" },
        { text: this.$t("DISPENSADO"), value: "DISPENSADO" },
      ],
      tiposBeneficioAvisoPrevio: [
        { text: this.$t("REDUCAODUASHORAS"), value: "REDUCAODUASHORAS" },
        { text: this.$t("REDUCAOSETEDIAS"), value: "REDUCAOSETEDIAS" },
      ],

      tiposOrigemAvisoPrevio: [
        { text: this.$t("EMPRESA"), value: "EMPRESA" },
        { text: this.$t("COLABORADOR"), value: "COLABORADOR" },
      ],
      errors: [],
    };
  },
  methods: {
    emitSubmitSuccess() {
      this.$emit("submitSuccessInsert");
    },
    emitSubmitError() {
      this.$emit("submitErrorInsert");
    },
    closeModal() {
      this.$emit("closeModalInsert");
    },
    submitForm() {
      return new Promise((resolve, reject) => {
        const selecionados = Array.isArray(this.selectedFuncionario)
          ? this.selectedFuncionario
          : [];

        if (!selecionados.length) {
          reject([
            {
              fieldName: this.$t("Funcionario"),
              message: "Selecione pelo menos um funcionário.",
            },
          ]);
          return;
        }

        const requests = selecionados.map((item) => {
          const funcionario = this.getFuncionarioData(item);
          const payload = {
            ...this.recurso,
            matricula: funcionario?.matricula || "",
            funcionario: funcionario?.id ? { id: funcionario.id } : funcionario,
          };

          return DataService.create(this.limpaMascara(payload));
        });

        Promise.allSettled(requests).then((results) => {
          const errors = [];
          const failedItems = [];

          results.forEach((result, index) => {
            if (result.status === "rejected") {
              const item = selecionados[index];
              failedItems.push(item);

              const identificacao = this.formatFuncionarioLabel(item);
              const backendErrors = result?.reason?.response?.data?.errors;

              if (Array.isArray(backendErrors) && backendErrors.length) {
                backendErrors.forEach((err) => {
                  errors.push({
                    fieldName: err.fieldName
                      ? `${identificacao} - ${err.fieldName}`
                      : identificacao,
                    message: err.message || err,
                  });
                });
              } else {
                errors.push({
                  fieldName: identificacao,
                  message:
                    result?.reason?.message ||
                    "Erro ao salvar o aviso prévio para o funcionário.",
                });
              }
            }
          });

          if (errors.length) {
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            this.selectedFuncionario = failedItems;
            this.errors = errors;
            reject(errors);
            return;
          }

          this.errors = [];
          this.submited = true;
          this.selectedFuncionario = [];
          this.recurso = {
            funcionario: {},
            matricula: "",
            inicio: "",
            encerramento: "",
            tipoAvisoPrevio: "",
            beneficioAvisoPrevio: "",
            origemAvisoPrevio: "",
            observacao: null,
            dataHomologacao: null,
          };
          resolve();
        });
      });
    },
    getFuncionarioData(item) {
      if (item && item.funcionario) return item.funcionario;
      return item || {};
    },
    formatFuncionarioLabel(item) {
      const funcionario = this.getFuncionarioData(item);
      const matricula = funcionario.matricula || "";
      const nome =
        funcionario?.pessoa?.nome ||
        funcionario.nomeSocial ||
        funcionario.nome ||
        "";

      if (matricula && nome) return `${matricula} - ${nome}`;
      return nome || matricula || this.$t("Funcionario");
    },
  },
  watch: {
    selectedFuncionario(newVal) {
      const funcionarioSelecionado =
        Array.isArray(newVal) && newVal.length
          ? this.getFuncionarioData(newVal[0])
          : null;

      if (funcionarioSelecionado) {
        this.recurso.matricula = funcionarioSelecionado.matricula;
        this.recurso.funcionario = funcionarioSelecionado;
      } else {
        this.recurso.matricula = "";
        this.recurso.funcionario = null;
      }
    },
  },
  beforeInsert() {
    return Array.isArray(this.selectedFuncionario)
      ? this.selectedFuncionario.length
      : 0;
  },
};
</script>

<style scoped>
#app .INATIVO {
  color: red;
}
</style>
